import { render, staticRenderFns } from "./EnrollExamStudentResultDesc.vue?vue&type=template&id=63d8d4e6&scoped=true"
import script from "./EnrollExamStudentResultDesc.vue?vue&type=script&lang=js"
export * from "./EnrollExamStudentResultDesc.vue?vue&type=script&lang=js"
import style0 from "./EnrollExamStudentResultDesc.vue?vue&type=style&index=0&id=63d8d4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8d4e6",
  null
  
)

export default component.exports